import React from 'react';
import PropTypes from 'prop-types';
import bindUserActions from '../user/redux/bindUserActions';
import { isPlus, subIsTeams } from './';

function SectionActions({ sectionType, user, actions }) {
  const plusSub = isPlus(user);
  const hasTeams = plusSub && subIsTeams(plusSub);
  const hasIndividual = plusSub && !subIsTeams(plusSub);

  // No subscription (free user)
  if (!plusSub) {
    if (sectionType === 'basic') {
      return (
        <div className='layer-actions'>
          <div className='status-indicator active'>
            <i className='glyphicon glyphicon-ok'></i> Active
          </div>
        </div>
      );
    } else {
      return (
        <div className='layer-actions'>
          <a href='#' className='learn-more'>Learn more</a>
          <a
            href='#'
            className='btn btn-primary upgrade-btn'
            onClick={(e) => {
              e.preventDefault();
              actions.doModal({ type: 'plus-subscription' });
            }}
          >
            Upgrade now
          </a>
        </div>
      );
    }
  }

  // AWN+ Individual
  if (hasIndividual) {
    if (sectionType === 'basic') {
      return null;
    } else {
      return (
        <div className='layer-actions'>
          <div className='status-indicator active'>
            <i className='glyphicon glyphicon-ok'></i> Active
          </div>
          <a
            href='#'
            className='btn btn-primary upgrade-btn'
            onClick={(e) => {
              e.preventDefault();
              actions.doModal({ 
                type: 'plus-subscription',
                data: {
                  tier: 'teams',
                  forceChange: true,
                }
              });
            }}
          >
            Upgrade to Teams
          </a>
        </div>
      );
    }
  }

  // AWN+ Teams
  if (hasTeams) {
    if (sectionType === 'basic') {
      return null;
    } else {
      return (
        <div className='layer-actions'>
          <div className='status-indicator active'>
            <i className='glyphicon glyphicon-ok'></i> Active
          </div>
        </div>
      );
    }
  }

  return null;
}

SectionActions.propTypes = {
  sectionType: PropTypes.oneOf(['basic', 'advanced']).isRequired,
  user: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default bindUserActions(SectionActions);

SectionActions.displayName = 'SectionActions'
